var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAudioOffSpeakerOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 40,
    viewBox: "0 0 74 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_69)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9167 14.1042V24.8959C40.9167 25.5402 41.4391 26.0626 42.0834 26.0626H49.6667L57.9492 33.1618C58.7059 33.8105 59.8751 33.2727 59.8751 32.276V6.13382C59.8751 5.11513 58.661 4.58572 57.9146 5.27889L49.6667 12.9376H42.0834C41.4391 12.9376 40.9167 13.4599 40.9167 14.1042ZM67.2263 10.8283C66.8667 10.3429 66.1818 10.2409 65.6964 10.6004C65.211 10.9599 65.1089 11.6449 65.4684 12.1303C66.9942 14.1903 67.8962 16.7383 67.8962 19.5001C67.8962 22.262 66.9942 24.81 65.4684 26.87C65.1089 27.3554 65.211 28.0404 65.6964 28.3999C66.1818 28.7594 66.8667 28.6574 67.2263 28.172C69.0216 25.7481 70.0837 22.7466 70.0837 19.5001C70.0837 16.2537 69.0216 13.2522 67.2263 10.8283ZM64.483 14.6465C64.1954 14.1153 63.5317 13.9178 63.0004 14.2054C62.4692 14.493 62.2717 15.1567 62.5593 15.6879C63.1725 16.8207 63.5211 18.1181 63.5211 19.5001C63.5211 20.8822 63.1725 22.1795 62.5593 23.3123C62.2717 23.8435 62.4692 24.5073 63.0004 24.7949C63.5317 25.0824 64.1954 24.8849 64.483 24.3537C65.265 22.909 65.7086 21.2548 65.7086 19.5001C65.7086 17.7455 65.265 16.0912 64.483 14.6465Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4598 2L33 37.4598Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2494 3H18.2494C14.5466 3 11.5449 6.0017 11.5449 9.70448V19.7612C11.5449 23.464 14.5466 26.4657 18.2494 26.4657H18.2494C21.9522 26.4657 24.9539 23.464 24.9539 19.7612V9.70448C24.9539 6.0017 21.9522 3 18.2494 3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54075 21.015C9.44275 20.3277 8.88935 19.7617 8.19515 19.7617C7.50085 19.7617 6.93065 20.3267 7.00685 21.0167C7.58575 26.2618 11.7499 30.4266 16.9947 31.0064V35.2658H13.2234C12.5291 35.2658 11.9663 35.8286 11.9663 36.5229C11.9663 37.2171 12.5291 37.7799 13.2234 37.7799H23.2801C23.9744 37.7799 24.5372 37.2171 24.5372 36.5229C24.5372 35.8286 23.9744 35.2658 23.2801 35.2658H19.5089V31.0064C24.7536 30.4266 28.9179 26.2618 29.4968 21.0167C29.5729 20.3267 29.0028 19.7617 28.3085 19.7617C27.6142 19.7617 27.0608 20.3277 26.9628 21.015C26.3545 25.2813 22.6862 28.5613 18.2518 28.5613C13.8174 28.5613 10.1491 25.2813 9.54075 21.015Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4598 5L0 40.4598Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4598 5L0 40.4598",
    stroke: "#EE6762",
    strokeWidth: 2.65949,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudioOffSpeakerOn);
export default __webpack_public_path__ + "static/media/icon_audio_off_speaker_on.73db682d78f0a46ab77e3ebd67a33f8f.svg";
export { ForwardRef as ReactComponent };